// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hold-drawer-paper {
  width: min(92vw, 980px) !important;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

/* ── Header New ── */
.hold-drawer-header-new {
  border-bottom: 1px solid #e2e8f0; /* border-slate-200 */
  background-color: #ffffff;
  flex-shrink: 0;
}

.hold-drawer-header-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px; /* px-5 py-4 */
}

@media (min-width: 640px) {
  .hold-drawer-header-inner {
    padding: 16px 24px; /* sm:px-6 */
  }
}

.hold-drawer-header-title {
  font-size: 26px;
  font-weight: 700;
  letter-spacing: -0.025em; /* tracking-tight */
  color: #0f172a; /* text-slate-900 */
  margin: 0;
}

.hold-drawer-scope-switch {
  display: inline-flex;
  flex-shrink: 0;
  gap: 4px;
  padding: 4px;
  margin-left: auto;
  margin-right: 12px;
  border-radius: 12px;
  background: #f1f5f9;
}

.hold-drawer-scope-switch .hold-drawer-tab-btn-new:focus-visible {
  outline: 2px solid #2563eb;
  outline-offset: 2px;
}

.dark .hold-drawer-scope-switch {
  background: #0f172a;
}

@media (max-width: 420px) {
  .hold-drawer-header-inner { flex-wrap: wrap; gap: 10px; }
  .hold-drawer-scope-switch { order: 3; margin: 0; width: 100%; justify-content: center; }
}

.hold-drawer-close-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: all 0.2s;
  width: 40px;
  height: 40px;
  border-radius: 9999px;
  border: 1px solid transparent;
  background: transparent;
  cursor: pointer;
}

.hold-drawer-close-btn:hover {
  background-color: #f1f5f9; /* hover:bg-slate-100 */
}

.hold-drawer-close-btn svg {
  width: 20px;
  height: 20px;
  color: #64748b; /* text-slate-500 */
}

/* ── Toolbar New ── */
.hold-drawer-toolbar-new {
  border-top: 1px solid #f1f5f9; /* border-slate-100 */
  padding: 12px 20px; /* px-5 py-3 */
}

@media (min-width: 640px) {
  .hold-drawer-toolbar-new {
    padding: 12px 24px; /* sm:px-6 */
  }
}

.hold-drawer-toolbar-inner {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

@media (min-width: 1024px) {
  .hold-drawer-toolbar-inner {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
}

.hold-drawer-tabs-new {
  display: inline-flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px;
  border-radius: 16px;
  border: 1px solid #e2e8f0;
  background-color: rgba(241, 245, 249, 0.9); /* bg-slate-100/90 */
  padding: 4px;
  width: fit-content;
}

.hold-drawer-tab-btn-new {
  border-radius: 20px;
  padding: 6px 14px;
  font-size: 13px;
  font-weight: 600;
  transition: all 0.2s;
  background: transparent;
  border: none;
  color: #64748b; /* text-slate-500 */
  cursor: pointer;
}

.hold-drawer-tab-btn-new:hover {
  color: #334155; /* hover:text-slate-700 */
}

.hold-drawer-tab-btn-new.active {
  background-color: #ffffff;
  color: #0f172a; /* text-slate-900 */
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06); /* shadow-sm */
}

.hold-drawer-search-new {
  position: relative;
  min-width: 240px;
  flex: 1;
}

@media (min-width: 1024px) {
  .hold-drawer-search-new {
    width: 288px; /* w-72 */
    flex: none;
  }
}

.hold-drawer-search-new svg {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  width: 16px;
  height: 16px;
  color: #94a3b8; /* text-slate-400 */
  pointer-events: none;
}

.hold-drawer-search-input-new {
  display: flex;
  width: 100%;
  height: 40px;
  border-radius: 16px;
  border: 1px solid #e2e8f0; /* border-slate-200 */
  background-color: #f1f5f9; /* bg-slate-100 */
  padding-left: 36px;
  padding-right: 12px;
  font-size: 14px;
  outline: none;
  transition: background-color 0.2s;
}

.hold-drawer-search-input-new:focus {
  background-color: #ffffff;
  border-color: #cbd5e1;
}

.hold-drawer-search-input-new::placeholder {
  color: #94a3b8;
}

/* ── Body ── */
.hold-drawer-body {
  overflow-y: auto;
  flex: 1;
  background-color: #f8fafc; /* bg-slate-50 */
  padding: 20px; /* p-5 */
}

@media (min-width: 640px) {
  .hold-drawer-body {
    padding: 24px; /* sm:p-6 */
  }
}

@media (max-width: 560px) {
  .hold-drawer-paper {
    width: 100vw !important;
  }
}

/* ── Loader / Empty ── */
.hold-drawer-loader {
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;
  padding: 60px 0;
}

.hold-drawer-empty {
  text-align: center;
  padding: 48px 20px;
  color: #9ca3af;
  font-size: 0.85rem;
}

/* ── Table Container & Layout ── */
.hold-drawer-table-container {
  overflow: hidden;
  border-radius: 24px;
  border: 1px solid #e2e8f0; /* border-slate-200 */
  background-color: #ffffff;
  box-shadow: 0 16px 40px rgba(15, 23, 42, 0.05); /* shadow */
}

.hold-drawer-table-header {
  display: grid;
  grid-template-columns: minmax(0, 0.7fr) minmax(0, 1fr) minmax(0, 0.8fr) minmax(0, 0.9fr) minmax(0, 1.1fr) minmax(0, 0.7fr) minmax(0, 1.8fr);
  align-items: center;
  gap: 16px;
  border-bottom: 1px solid #e2e8f0;
  background-color: #f8fafc;
  padding: 12px 20px;
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.14em;
  color: #64748b; /* text-slate-500 */
}

.hold-drawer-table-body {
  display: flex;
  flex-direction: column;
}

/* Row divider */
.hold-drawer-table-body > * + * {
  border-top: 1px solid #f1f5f9; /* divide-slate-100 */
}

.hold-drawer-table-row {
  display: grid;
  grid-template-columns: minmax(0, 0.7fr) minmax(0, 1fr) minmax(0, 0.8fr) minmax(0, 0.9fr) minmax(0, 1.1fr) minmax(0, 0.7fr) minmax(0, 1.8fr);
  align-items: center;
  gap: 16px;
  padding: 14px 20px;
  transition: background-color 0.2s;
}

.hold-drawer-table-row:hover {
  background-color: rgba(248, 250, 252, 0.8); /* hover:bg-slate-50/80 */
}

/* ── Column 1: Order ── */
.hold-drawer-order-id-badge {
  display: flex;
  height: 40px;
  width: 75px;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  border-radius: 20px;
  background-color: #f1f5f9; /* bg-slate-100 */
  font-size: 13px;
  font-weight: 700;
  color: #334155; /* text-slate-700 */
}

.hold-drawer-customer-name-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 14px;
  font-weight: 700;
  color: #0f172a; /* text-slate-900 */
  margin: 0;
}

.hold-drawer-item-count-text {
  margin-top: 2px;
  font-size: 12px;
  color: #64748b; /* text-slate-500 */
  margin-bottom: 0;
}

.hold-drawer-products-text {
  margin-top: 2px;
  font-size: 11px;
  color: #64748b; /* text-slate-500 */
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-bottom: 0;
}

/* ── Column 2: Type ── */
.hold-drawer-type-badge {
  white-space: nowrap;
  transition: all 0.2s;
  border: 1px solid transparent;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border-radius: 9999px;
  padding: 4px 10px;
  font-size: 11px;
  font-weight: 600;
  width: fit-content;
}

.hold-drawer-type-badge svg {
  width: 16px;
  height: 16px;
}

.hd-badge-dine-in {
  color: #2563eb; /* text-blue-600 */
  background-color: #eff6ff; /* bg-blue-50 */
  border-color: #bfdbfe; /* border-blue-200 */
}

.hd-badge-delivery {
  color: #ea580c; /* text-orange-600 */
  background-color: #fff7ed; /* bg-orange-50 */
  border-color: #ffedd5; /* border-orange-200 */
}

.hd-badge-takeaway {
  color: #059669; /* text-emerald-600 */
  background-color: #ecfdf5; /* bg-emerald-50 */
  border-color: #a7f3d0; /* border-emerald-200 */
}

.hd-badge-pos {
  color: #475569; /* text-slate-600 */
  background-color: #f1f5f9; /* bg-slate-100 */
  border-color: #cbd5e1; /* border-slate-300 */
}

/* ── Column 3: Time ── */
.hold-drawer-time-cell {
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 8px; /* gap-2 */
  font-size: 14px;
  color: #475569; /* text-slate-600 */
}

.hold-drawer-time-cell svg {
  height: 16px;
  width: 16px;
  flex-shrink: 0;
  color: #94a3b8; /* text-slate-400 */
}

.hold-drawer-time-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* ── Column 4: Value ── */
.hold-drawer-value-cell {
  text-align: right;
}

.hold-drawer-total-text {
  font-size: 16px;
  font-weight: 700;
  color: #0f172a; /* text-slate-900 */
}

/* ── Column 5: Actions ── */
.hold-drawer-actions-cell {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px; /* gap-2 */
}

.hd-btn-discard-table {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  white-space: nowrap;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s;
  border: 1px solid transparent;
  min-height: 36px;
  padding: 8px 16px;
  border-radius: 9999px;
  color: #dc2626; /* text-red-600 */
  background: transparent;
  cursor: pointer;
}

.hd-btn-discard-table:hover:not(:disabled) {
  background-color: #fef2f2; /* hover:bg-red-50 */
  color: #b91c1c; /* hover:text-red-700 */
}

.hd-btn-discard-table svg,
.hd-btn-retrieve-table svg {
  pointer-events: none;
  width: 16px;
  height: 16px;
  flex-shrink: 0;
}

.hd-btn-retrieve-table {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  white-space: nowrap;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s;
  border: 1px solid #e2e8f0; /* border-slate-200 */
  min-height: 36px;
  padding: 8px 16px;
  border-radius: 9999px;
  background-color: #0f172a; /* bg-slate-900 */
  color: #ffffff;
  cursor: pointer;
}

.hd-btn-retrieve-table:hover:not(:disabled) {
  background-color: #1e293b; /* hover:bg-slate-800 */
}

.hd-btn-discard-table:disabled,
.hd-btn-retrieve-table:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.discard-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

/* ── Pagination Styles ── */
.hold-drawer-pagination {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 24px;
  background-color: #ffffff;
  border-top: 1px solid #e2e8f0;
}

.hold-drawer-pagination-text {
  font-size: 14px;
  font-weight: 500;
  color: #64748b; /* text-slate-500 */
}

.hold-drawer-pagination-btns {
  display: flex;
  align-items: center;
  gap: 12px;
}

.hold-drawer-page-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: 1px solid #e2e8f0;
  background-color: #ffffff;
  color: #64748b;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  outline: none;
}

.hold-drawer-page-btn:hover:not(:disabled) {
  background-color: #f1f5f9;
  color: #0f172a;
  border-color: #cbd5e1;
}

.hold-drawer-page-btn:disabled {
  opacity: 0.35;
  cursor: not-allowed;
  background-color: #f8fafc;
}

.hold-drawer-page-btn svg {
  width: 16px;
  height: 16px;
}

/* ── Discard Confirmation Modal ── */
.hod-discard-modal-box {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: calc(100% - 32px);
  max-width: 448px; /* sm:max-w-md */
  background-color: #ffffff;
  border-radius: 16px; /* rounded-2xl */
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25); /* shadow-2xl */
  outline: none;
  overflow: hidden;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}

.hod-discard-modal-close-btn {
  position: absolute;
  right: 16px; /* right-4 */
  top: 16px; /* top-4 */
  background: transparent;
  border: none;
  cursor: pointer;
  opacity: 0.7;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.2s ease;
  color: #64748b;
  padding: 4px;
  outline: none;
}

.hod-discard-modal-close-btn:hover {
  opacity: 1;
}

.hod-discard-modal-close-btn svg {
  width: 16px; /* h-4 w-4 */
  height: 16px;
}

.hod-discard-modal-header {
  display: flex;
  flex-direction: column;
  padding: 24px; /* p-6 */
  background-color: #ffffff;
  border-bottom: 1px solid #f1f5f9; /* border-slate-100 */
}

.hod-discard-modal-title {
  font-size: 20px; /* text-xl */
  font-weight: 700; /* font-bold */
  letter-spacing: -0.025em; /* tracking-tight */
  color: #dc2626; /* text-red-600 */
  margin: 0;
  display: flex;
  align-items: center;
  gap: 8px; /* gap-2 */
}

.hod-discard-modal-actions {
  display: flex;
  flex-direction: column-reverse;
  padding: 24px; /* p-6 */
  background-color: #f8fafc; /* bg-slate-50 */
  gap: 12px; /* gap-3 */
}

@media (min-width: 640px) {
  .hod-discard-modal-actions {
    flex-direction: row;
    justify-content: flex-end;
  }
}

.hod-discard-modal-btn-cancel {
  flex: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  white-space: nowrap;
  font-size: 14px; /* text-sm */
  font-weight: 500; /* font-medium */
  height: 44px; /* h-11 */
  border-radius: 20px; /* rounded-xl */
  border: 1px solid #e2e8f0; /* border-slate-200 */
  background-color: #ffffff;
  color: #475569; /* text-slate-600 */
  cursor: pointer;
  transition: all 0.2s;
  outline: none;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05); /* shadow-xs */
}

.hod-discard-modal-btn-cancel:hover {
  background-color: #f1f5f9; /* hover:bg-slate-100 */
}

.hod-discard-modal-btn-confirm {
  flex: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  white-space: nowrap;
  font-size: 14px; /* text-sm */
  font-weight: 700; /* font-bold */
  height: 44px; /* h-11 */
  border-radius: 20px; /* rounded-xl */
  border: 1px solid #dc2626; /* bg-red-600 */
  background-color: #dc2626;
  color: #ffffff;
  cursor: pointer;
  transition: all 0.2s;
  outline: none;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05); /* shadow-sm */
}

.hod-discard-modal-btn-confirm:hover {
  background-color: #b91c1c; /* hover:bg-red-700 */
  border-color: #b91c1c;
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

/* ── Dark mode ── */
.dark .hold-drawer-paper {
  background: #1e293b !important;
}

.dark .hold-drawer-header-new {
  background-color: #1e293b;
  border-bottom-color: #334155;
}

.dark .hold-drawer-header-title {
  color: #f1f5f9;
}

.dark .hold-drawer-close-btn:hover {
  background-color: #334155;
}

.dark .hold-drawer-close-btn svg {
  color: #94a3b8;
}

.dark .hold-drawer-toolbar-new {
  border-top-color: #334155;
}

.dark .hold-drawer-tabs-new {
  background-color: #0f172a;
  border-color: #334155;
}

.dark .hold-drawer-tab-btn-new {
  color: #64748b;
}

.dark .hold-drawer-tab-btn-new:hover {
  color: #cbd5e1;
}

.dark .hold-drawer-tab-btn-new.active {
  background-color: #1e293b;
  color: #f1f5f9;
  box-shadow: 0 1px 3px rgba(0,0,0,0.4);
}

.dark .hold-drawer-search-input-new {
  background-color: #0f172a;
  border-color: #334155;
  color: #e2e8f0;
}

.dark .hold-drawer-search-input-new:focus {
  background-color: #1e293b;
  border-color: #475569;
}

.dark .hold-drawer-search-input-new::placeholder {
  color: #64748b;
}

.dark .hold-drawer-body {
  background-color: #0f172a;
}

.dark .hold-drawer-table-container {
  background-color: #1e293b;
  border-color: #334155;
  box-shadow: 0 8px 24px rgba(0,0,0,0.4);
}

.dark .hold-drawer-table-header {
  background-color: #162032;
  border-bottom-color: #334155;
  color: #64748b;
}

.dark .hold-drawer-table-body > * + * {
  border-top-color: #334155;
}

.dark .hold-drawer-table-row:hover {
  background-color: rgba(30, 41, 59, 0.8);
}

.dark .hold-drawer-order-id-badge {
  background-color: #0f172a;
  color: #94a3b8;
}

.dark .hold-drawer-customer-name-text {
  color: #f1f5f9;
}

.dark .hold-drawer-item-count-text,
.dark .hold-drawer-products-text {
  color: #64748b;
}

.dark .hold-drawer-time-cell {
  color: #94a3b8;
}

.dark .hold-drawer-total-text {
  color: #f1f5f9;
}

.dark .hold-drawer-pagination {
  background-color: #1e293b;
  border-top-color: #334155;
}

.dark .hold-drawer-pagination-text {
  color: #64748b;
}

.dark .hold-drawer-page-btn {
  background-color: #0f172a;
  border-color: #334155;
  color: #94a3b8;
}

.dark .hold-drawer-page-btn:hover:not(:disabled) {
  background-color: #1e293b;
  color: #f1f5f9;
  border-color: #475569;
}

.dark .hod-discard-modal-box {
  background-color: #1e293b;
}

.dark .hod-discard-modal-header {
  background-color: #1e293b;
  border-bottom-color: #334155;
}

.dark .hod-discard-modal-actions {
  background-color: #0f172a;
}

.dark .hod-discard-modal-btn-cancel {
  background-color: #1e293b;
  border-color: #334155;
  color: #94a3b8;
}

.dark .hod-discard-modal-btn-cancel:hover {
  background-color: #334155;
}
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/posnavbar/components/HoldOrderDrawer/HoldOrderDrawer.css"],"names":[],"mappings":"AAAA;EACE,kCAAkC;EAClC,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,gCAAgC,EAAE,qBAAqB;EACvD,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB,EAAE,cAAc;AACpC;;AAEA;EACE;IACE,kBAAkB,EAAE,YAAY;EAClC;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB,EAAE,mBAAmB;EAC7C,cAAc,EAAE,mBAAmB;EACnC,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,QAAQ;EACR,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,4BAA4B,eAAe,EAAE,SAAS,EAAE;EACxD,4BAA4B,QAAQ,EAAE,SAAS,EAAE,WAAW,EAAE,uBAAuB,EAAE;AACzF;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,6BAA6B;EAC7B,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,yBAAyB,EAAE,uBAAuB;AACpD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc,EAAE,mBAAmB;AACrC;;AAEA,sBAAsB;AACtB;EACE,6BAA6B,EAAE,qBAAqB;EACpD,kBAAkB,EAAE,cAAc;AACpC;;AAEA;EACE;IACE,kBAAkB,EAAE,YAAY;EAClC;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE;IACE,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;EAChC;AACF;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,yBAAyB;EACzB,0CAA0C,EAAE,oBAAoB;EAChE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,uBAAuB;EACvB,YAAY;EACZ,cAAc,EAAE,mBAAmB;EACnC,eAAe;AACjB;;AAEA;EACE,cAAc,EAAE,yBAAyB;AAC3C;;AAEA;EACE,yBAAyB;EACzB,cAAc,EAAE,mBAAmB;EACnC,2EAA2E,EAAE,cAAc;AAC7F;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,OAAO;AACT;;AAEA;EACE;IACE,YAAY,EAAE,SAAS;IACvB,UAAU;EACZ;AACF;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,cAAc,EAAE,mBAAmB;EACnC,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB,EAAE,qBAAqB;EAChD,yBAAyB,EAAE,iBAAiB;EAC5C,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA,eAAe;AACf;EACE,gBAAgB;EAChB,OAAO;EACP,yBAAyB,EAAE,gBAAgB;EAC3C,aAAa,EAAE,QAAQ;AACzB;;AAEA;EACE;IACE,aAAa,EAAE,WAAW;EAC5B;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;AACF;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,OAAO;EACP,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA,mCAAmC;AACnC;EACE,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB,EAAE,qBAAqB;EAChD,yBAAyB;EACzB,8CAA8C,EAAE,WAAW;AAC7D;;AAEA;EACE,aAAa;EACb,2IAA2I;EAC3I,mBAAmB;EACnB,SAAS;EACT,gCAAgC;EAChC,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc,EAAE,mBAAmB;AACrC;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA,gBAAgB;AAChB;EACE,6BAA6B,EAAE,qBAAqB;AACtD;;AAEA;EACE,aAAa;EACb,2IAA2I;EAC3I,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,0CAA0C,EAAE,yBAAyB;AACvE;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,YAAY;EACZ,WAAW;EACX,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB,EAAE,iBAAiB;EAC5C,eAAe;EACf,gBAAgB;EAChB,cAAc,EAAE,mBAAmB;AACrC;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc,EAAE,mBAAmB;EACnC,SAAS;AACX;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc,EAAE,mBAAmB;EACnC,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc,EAAE,mBAAmB;EACnC,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,yBAAyB;AACzB;EACE,mBAAmB;EACnB,oBAAoB;EACpB,6BAA6B;EAC7B,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,qBAAqB;EACrB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc,EAAE,kBAAkB;EAClC,yBAAyB,EAAE,eAAe;EAC1C,qBAAqB,EAAE,oBAAoB;AAC7C;;AAEA;EACE,cAAc,EAAE,oBAAoB;EACpC,yBAAyB,EAAE,iBAAiB;EAC5C,qBAAqB,EAAE,sBAAsB;AAC/C;;AAEA;EACE,cAAc,EAAE,qBAAqB;EACrC,yBAAyB,EAAE,kBAAkB;EAC7C,qBAAqB,EAAE,uBAAuB;AAChD;;AAEA;EACE,cAAc,EAAE,mBAAmB;EACnC,yBAAyB,EAAE,iBAAiB;EAC5C,qBAAqB,EAAE,qBAAqB;AAC9C;;AAEA,yBAAyB;AACzB;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,QAAQ,EAAE,UAAU;EACpB,eAAe;EACf,cAAc,EAAE,mBAAmB;AACrC;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,cAAc;EACd,cAAc,EAAE,mBAAmB;AACrC;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,0BAA0B;AAC1B;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc,EAAE,mBAAmB;AACrC;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,QAAQ,EAAE,UAAU;AACtB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,6BAA6B;EAC7B,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,cAAc,EAAE,iBAAiB;EACjC,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,yBAAyB,EAAE,oBAAoB;EAC/C,cAAc,EAAE,uBAAuB;AACzC;;AAEA;;EAEE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,yBAAyB,EAAE,qBAAqB;EAChD,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,yBAAyB,EAAE,iBAAiB;EAC5C,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,yBAAyB,EAAE,uBAAuB;AACpD;;AAEA;;EAEE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc,EAAE,mBAAmB;AACrC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,gCAAgC;EAChC,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,qCAAqC;AACrC;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,wBAAwB;EACxB,gBAAgB,EAAE,gBAAgB;EAClC,yBAAyB;EACzB,mBAAmB,EAAE,gBAAgB;EACrC,iDAAiD,EAAE,eAAe;EAClE,aAAa;EACb,gBAAgB;EAChB,sBAAsB;EACtB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,WAAW,EAAE,YAAY;EACzB,SAAS,EAAE,UAAU;EACrB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,cAAc;EACd,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW,EAAE,YAAY;EACzB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa,EAAE,QAAQ;EACvB,yBAAyB;EACzB,gCAAgC,EAAE,qBAAqB;AACzD;;AAEA;EACE,eAAe,EAAE,YAAY;EAC7B,gBAAgB,EAAE,cAAc;EAChC,wBAAwB,EAAE,mBAAmB;EAC7C,cAAc,EAAE,iBAAiB;EACjC,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,QAAQ,EAAE,UAAU;AACtB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,aAAa,EAAE,QAAQ;EACvB,yBAAyB,EAAE,gBAAgB;EAC3C,SAAS,EAAE,UAAU;AACvB;;AAEA;EACE;IACE,mBAAmB;IACnB,yBAAyB;EAC3B;AACF;;AAEA;EACE,OAAO;EACP,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;EACnB,eAAe,EAAE,YAAY;EAC7B,gBAAgB,EAAE,gBAAgB;EAClC,YAAY,EAAE,SAAS;EACvB,mBAAmB,EAAE,eAAe;EACpC,yBAAyB,EAAE,qBAAqB;EAChD,yBAAyB;EACzB,cAAc,EAAE,mBAAmB;EACnC,eAAe;EACf,oBAAoB;EACpB,aAAa;EACb,2CAA2C,EAAE,cAAc;AAC7D;;AAEA;EACE,yBAAyB,EAAE,uBAAuB;AACpD;;AAEA;EACE,OAAO;EACP,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;EACnB,eAAe,EAAE,YAAY;EAC7B,gBAAgB,EAAE,cAAc;EAChC,YAAY,EAAE,SAAS;EACvB,mBAAmB,EAAE,eAAe;EACpC,yBAAyB,EAAE,eAAe;EAC1C,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,aAAa;EACb,2CAA2C,EAAE,cAAc;AAC7D;;AAEA;EACE,yBAAyB,EAAE,qBAAqB;EAChD,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA,oBAAoB;AACpB;EACE,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".hold-drawer-paper {\n  width: min(92vw, 980px) !important;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n/* ── Header New ── */\n.hold-drawer-header-new {\n  border-bottom: 1px solid #e2e8f0; /* border-slate-200 */\n  background-color: #ffffff;\n  flex-shrink: 0;\n}\n\n.hold-drawer-header-inner {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px 20px; /* px-5 py-4 */\n}\n\n@media (min-width: 640px) {\n  .hold-drawer-header-inner {\n    padding: 16px 24px; /* sm:px-6 */\n  }\n}\n\n.hold-drawer-header-title {\n  font-size: 26px;\n  font-weight: 700;\n  letter-spacing: -0.025em; /* tracking-tight */\n  color: #0f172a; /* text-slate-900 */\n  margin: 0;\n}\n\n.hold-drawer-scope-switch {\n  display: inline-flex;\n  flex-shrink: 0;\n  gap: 4px;\n  padding: 4px;\n  margin-left: auto;\n  margin-right: 12px;\n  border-radius: 12px;\n  background: #f1f5f9;\n}\n\n.hold-drawer-scope-switch .hold-drawer-tab-btn-new:focus-visible {\n  outline: 2px solid #2563eb;\n  outline-offset: 2px;\n}\n\n.dark .hold-drawer-scope-switch {\n  background: #0f172a;\n}\n\n@media (max-width: 420px) {\n  .hold-drawer-header-inner { flex-wrap: wrap; gap: 10px; }\n  .hold-drawer-scope-switch { order: 3; margin: 0; width: 100%; justify-content: center; }\n}\n\n.hold-drawer-close-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  transition: all 0.2s;\n  width: 40px;\n  height: 40px;\n  border-radius: 9999px;\n  border: 1px solid transparent;\n  background: transparent;\n  cursor: pointer;\n}\n\n.hold-drawer-close-btn:hover {\n  background-color: #f1f5f9; /* hover:bg-slate-100 */\n}\n\n.hold-drawer-close-btn svg {\n  width: 20px;\n  height: 20px;\n  color: #64748b; /* text-slate-500 */\n}\n\n/* ── Toolbar New ── */\n.hold-drawer-toolbar-new {\n  border-top: 1px solid #f1f5f9; /* border-slate-100 */\n  padding: 12px 20px; /* px-5 py-3 */\n}\n\n@media (min-width: 640px) {\n  .hold-drawer-toolbar-new {\n    padding: 12px 24px; /* sm:px-6 */\n  }\n}\n\n.hold-drawer-toolbar-inner {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n@media (min-width: 1024px) {\n  .hold-drawer-toolbar-inner {\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n  }\n}\n\n.hold-drawer-tabs-new {\n  display: inline-flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 4px;\n  border-radius: 16px;\n  border: 1px solid #e2e8f0;\n  background-color: rgba(241, 245, 249, 0.9); /* bg-slate-100/90 */\n  padding: 4px;\n  width: fit-content;\n}\n\n.hold-drawer-tab-btn-new {\n  border-radius: 20px;\n  padding: 6px 14px;\n  font-size: 13px;\n  font-weight: 600;\n  transition: all 0.2s;\n  background: transparent;\n  border: none;\n  color: #64748b; /* text-slate-500 */\n  cursor: pointer;\n}\n\n.hold-drawer-tab-btn-new:hover {\n  color: #334155; /* hover:text-slate-700 */\n}\n\n.hold-drawer-tab-btn-new.active {\n  background-color: #ffffff;\n  color: #0f172a; /* text-slate-900 */\n  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06); /* shadow-sm */\n}\n\n.hold-drawer-search-new {\n  position: relative;\n  min-width: 240px;\n  flex: 1;\n}\n\n@media (min-width: 1024px) {\n  .hold-drawer-search-new {\n    width: 288px; /* w-72 */\n    flex: none;\n  }\n}\n\n.hold-drawer-search-new svg {\n  position: absolute;\n  left: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 16px;\n  height: 16px;\n  color: #94a3b8; /* text-slate-400 */\n  pointer-events: none;\n}\n\n.hold-drawer-search-input-new {\n  display: flex;\n  width: 100%;\n  height: 40px;\n  border-radius: 16px;\n  border: 1px solid #e2e8f0; /* border-slate-200 */\n  background-color: #f1f5f9; /* bg-slate-100 */\n  padding-left: 36px;\n  padding-right: 12px;\n  font-size: 14px;\n  outline: none;\n  transition: background-color 0.2s;\n}\n\n.hold-drawer-search-input-new:focus {\n  background-color: #ffffff;\n  border-color: #cbd5e1;\n}\n\n.hold-drawer-search-input-new::placeholder {\n  color: #94a3b8;\n}\n\n/* ── Body ── */\n.hold-drawer-body {\n  overflow-y: auto;\n  flex: 1;\n  background-color: #f8fafc; /* bg-slate-50 */\n  padding: 20px; /* p-5 */\n}\n\n@media (min-width: 640px) {\n  .hold-drawer-body {\n    padding: 24px; /* sm:p-6 */\n  }\n}\n\n@media (max-width: 560px) {\n  .hold-drawer-paper {\n    width: 100vw !important;\n  }\n}\n\n/* ── Loader / Empty ── */\n.hold-drawer-loader {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex: 1;\n  padding: 60px 0;\n}\n\n.hold-drawer-empty {\n  text-align: center;\n  padding: 48px 20px;\n  color: #9ca3af;\n  font-size: 0.85rem;\n}\n\n/* ── Table Container & Layout ── */\n.hold-drawer-table-container {\n  overflow: hidden;\n  border-radius: 24px;\n  border: 1px solid #e2e8f0; /* border-slate-200 */\n  background-color: #ffffff;\n  box-shadow: 0 16px 40px rgba(15, 23, 42, 0.05); /* shadow */\n}\n\n.hold-drawer-table-header {\n  display: grid;\n  grid-template-columns: minmax(0, 0.7fr) minmax(0, 1fr) minmax(0, 0.8fr) minmax(0, 0.9fr) minmax(0, 1.1fr) minmax(0, 0.7fr) minmax(0, 1.8fr);\n  align-items: center;\n  gap: 16px;\n  border-bottom: 1px solid #e2e8f0;\n  background-color: #f8fafc;\n  padding: 12px 20px;\n  font-size: 10px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.14em;\n  color: #64748b; /* text-slate-500 */\n}\n\n.hold-drawer-table-body {\n  display: flex;\n  flex-direction: column;\n}\n\n/* Row divider */\n.hold-drawer-table-body > * + * {\n  border-top: 1px solid #f1f5f9; /* divide-slate-100 */\n}\n\n.hold-drawer-table-row {\n  display: grid;\n  grid-template-columns: minmax(0, 0.7fr) minmax(0, 1fr) minmax(0, 0.8fr) minmax(0, 0.9fr) minmax(0, 1.1fr) minmax(0, 0.7fr) minmax(0, 1.8fr);\n  align-items: center;\n  gap: 16px;\n  padding: 14px 20px;\n  transition: background-color 0.2s;\n}\n\n.hold-drawer-table-row:hover {\n  background-color: rgba(248, 250, 252, 0.8); /* hover:bg-slate-50/80 */\n}\n\n/* ── Column 1: Order ── */\n.hold-drawer-order-id-badge {\n  display: flex;\n  height: 40px;\n  width: 75px;\n  flex-shrink: 0;\n  align-items: center;\n  justify-content: center;\n  border-radius: 20px;\n  background-color: #f1f5f9; /* bg-slate-100 */\n  font-size: 13px;\n  font-weight: 700;\n  color: #334155; /* text-slate-700 */\n}\n\n.hold-drawer-customer-name-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-size: 14px;\n  font-weight: 700;\n  color: #0f172a; /* text-slate-900 */\n  margin: 0;\n}\n\n.hold-drawer-item-count-text {\n  margin-top: 2px;\n  font-size: 12px;\n  color: #64748b; /* text-slate-500 */\n  margin-bottom: 0;\n}\n\n.hold-drawer-products-text {\n  margin-top: 2px;\n  font-size: 11px;\n  color: #64748b; /* text-slate-500 */\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  margin-bottom: 0;\n}\n\n/* ── Column 2: Type ── */\n.hold-drawer-type-badge {\n  white-space: nowrap;\n  transition: all 0.2s;\n  border: 1px solid transparent;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  border-radius: 9999px;\n  padding: 4px 10px;\n  font-size: 11px;\n  font-weight: 600;\n  width: fit-content;\n}\n\n.hold-drawer-type-badge svg {\n  width: 16px;\n  height: 16px;\n}\n\n.hd-badge-dine-in {\n  color: #2563eb; /* text-blue-600 */\n  background-color: #eff6ff; /* bg-blue-50 */\n  border-color: #bfdbfe; /* border-blue-200 */\n}\n\n.hd-badge-delivery {\n  color: #ea580c; /* text-orange-600 */\n  background-color: #fff7ed; /* bg-orange-50 */\n  border-color: #ffedd5; /* border-orange-200 */\n}\n\n.hd-badge-takeaway {\n  color: #059669; /* text-emerald-600 */\n  background-color: #ecfdf5; /* bg-emerald-50 */\n  border-color: #a7f3d0; /* border-emerald-200 */\n}\n\n.hd-badge-pos {\n  color: #475569; /* text-slate-600 */\n  background-color: #f1f5f9; /* bg-slate-100 */\n  border-color: #cbd5e1; /* border-slate-300 */\n}\n\n/* ── Column 3: Time ── */\n.hold-drawer-time-cell {\n  min-width: 0;\n  display: flex;\n  align-items: center;\n  gap: 8px; /* gap-2 */\n  font-size: 14px;\n  color: #475569; /* text-slate-600 */\n}\n\n.hold-drawer-time-cell svg {\n  height: 16px;\n  width: 16px;\n  flex-shrink: 0;\n  color: #94a3b8; /* text-slate-400 */\n}\n\n.hold-drawer-time-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n/* ── Column 4: Value ── */\n.hold-drawer-value-cell {\n  text-align: right;\n}\n\n.hold-drawer-total-text {\n  font-size: 16px;\n  font-weight: 700;\n  color: #0f172a; /* text-slate-900 */\n}\n\n/* ── Column 5: Actions ── */\n.hold-drawer-actions-cell {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 8px; /* gap-2 */\n}\n\n.hd-btn-discard-table {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  white-space: nowrap;\n  font-size: 14px;\n  font-weight: 500;\n  transition: all 0.2s;\n  border: 1px solid transparent;\n  min-height: 36px;\n  padding: 8px 16px;\n  border-radius: 9999px;\n  color: #dc2626; /* text-red-600 */\n  background: transparent;\n  cursor: pointer;\n}\n\n.hd-btn-discard-table:hover:not(:disabled) {\n  background-color: #fef2f2; /* hover:bg-red-50 */\n  color: #b91c1c; /* hover:text-red-700 */\n}\n\n.hd-btn-discard-table svg,\n.hd-btn-retrieve-table svg {\n  pointer-events: none;\n  width: 16px;\n  height: 16px;\n  flex-shrink: 0;\n}\n\n.hd-btn-retrieve-table {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  white-space: nowrap;\n  font-size: 14px;\n  font-weight: 500;\n  transition: all 0.2s;\n  border: 1px solid #e2e8f0; /* border-slate-200 */\n  min-height: 36px;\n  padding: 8px 16px;\n  border-radius: 9999px;\n  background-color: #0f172a; /* bg-slate-900 */\n  color: #ffffff;\n  cursor: pointer;\n}\n\n.hd-btn-retrieve-table:hover:not(:disabled) {\n  background-color: #1e293b; /* hover:bg-slate-800 */\n}\n\n.hd-btn-discard-table:disabled,\n.hd-btn-retrieve-table:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.discard-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.7);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n/* ── Pagination Styles ── */\n.hold-drawer-pagination {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px 24px;\n  background-color: #ffffff;\n  border-top: 1px solid #e2e8f0;\n}\n\n.hold-drawer-pagination-text {\n  font-size: 14px;\n  font-weight: 500;\n  color: #64748b; /* text-slate-500 */\n}\n\n.hold-drawer-pagination-btns {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.hold-drawer-page-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  border: 1px solid #e2e8f0;\n  background-color: #ffffff;\n  color: #64748b;\n  cursor: pointer;\n  transition: all 0.2s ease-in-out;\n  outline: none;\n}\n\n.hold-drawer-page-btn:hover:not(:disabled) {\n  background-color: #f1f5f9;\n  color: #0f172a;\n  border-color: #cbd5e1;\n}\n\n.hold-drawer-page-btn:disabled {\n  opacity: 0.35;\n  cursor: not-allowed;\n  background-color: #f8fafc;\n}\n\n.hold-drawer-page-btn svg {\n  width: 16px;\n  height: 16px;\n}\n\n/* ── Discard Confirmation Modal ── */\n.hod-discard-modal-box {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: calc(100% - 32px);\n  max-width: 448px; /* sm:max-w-md */\n  background-color: #ffffff;\n  border-radius: 16px; /* rounded-2xl */\n  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25); /* shadow-2xl */\n  outline: none;\n  overflow: hidden;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n}\n\n.hod-discard-modal-close-btn {\n  position: absolute;\n  right: 16px; /* right-4 */\n  top: 16px; /* top-4 */\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  opacity: 0.7;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  transition: opacity 0.2s ease;\n  color: #64748b;\n  padding: 4px;\n  outline: none;\n}\n\n.hod-discard-modal-close-btn:hover {\n  opacity: 1;\n}\n\n.hod-discard-modal-close-btn svg {\n  width: 16px; /* h-4 w-4 */\n  height: 16px;\n}\n\n.hod-discard-modal-header {\n  display: flex;\n  flex-direction: column;\n  padding: 24px; /* p-6 */\n  background-color: #ffffff;\n  border-bottom: 1px solid #f1f5f9; /* border-slate-100 */\n}\n\n.hod-discard-modal-title {\n  font-size: 20px; /* text-xl */\n  font-weight: 700; /* font-bold */\n  letter-spacing: -0.025em; /* tracking-tight */\n  color: #dc2626; /* text-red-600 */\n  margin: 0;\n  display: flex;\n  align-items: center;\n  gap: 8px; /* gap-2 */\n}\n\n.hod-discard-modal-actions {\n  display: flex;\n  flex-direction: column-reverse;\n  padding: 24px; /* p-6 */\n  background-color: #f8fafc; /* bg-slate-50 */\n  gap: 12px; /* gap-3 */\n}\n\n@media (min-width: 640px) {\n  .hod-discard-modal-actions {\n    flex-direction: row;\n    justify-content: flex-end;\n  }\n}\n\n.hod-discard-modal-btn-cancel {\n  flex: 1;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  white-space: nowrap;\n  font-size: 14px; /* text-sm */\n  font-weight: 500; /* font-medium */\n  height: 44px; /* h-11 */\n  border-radius: 20px; /* rounded-xl */\n  border: 1px solid #e2e8f0; /* border-slate-200 */\n  background-color: #ffffff;\n  color: #475569; /* text-slate-600 */\n  cursor: pointer;\n  transition: all 0.2s;\n  outline: none;\n  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05); /* shadow-xs */\n}\n\n.hod-discard-modal-btn-cancel:hover {\n  background-color: #f1f5f9; /* hover:bg-slate-100 */\n}\n\n.hod-discard-modal-btn-confirm {\n  flex: 1;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  white-space: nowrap;\n  font-size: 14px; /* text-sm */\n  font-weight: 700; /* font-bold */\n  height: 44px; /* h-11 */\n  border-radius: 20px; /* rounded-xl */\n  border: 1px solid #dc2626; /* bg-red-600 */\n  background-color: #dc2626;\n  color: #ffffff;\n  cursor: pointer;\n  transition: all 0.2s;\n  outline: none;\n  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05); /* shadow-sm */\n}\n\n.hod-discard-modal-btn-confirm:hover {\n  background-color: #b91c1c; /* hover:bg-red-700 */\n  border-color: #b91c1c;\n}\n\n.sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n}\n\n/* ── Dark mode ── */\n.dark .hold-drawer-paper {\n  background: #1e293b !important;\n}\n\n.dark .hold-drawer-header-new {\n  background-color: #1e293b;\n  border-bottom-color: #334155;\n}\n\n.dark .hold-drawer-header-title {\n  color: #f1f5f9;\n}\n\n.dark .hold-drawer-close-btn:hover {\n  background-color: #334155;\n}\n\n.dark .hold-drawer-close-btn svg {\n  color: #94a3b8;\n}\n\n.dark .hold-drawer-toolbar-new {\n  border-top-color: #334155;\n}\n\n.dark .hold-drawer-tabs-new {\n  background-color: #0f172a;\n  border-color: #334155;\n}\n\n.dark .hold-drawer-tab-btn-new {\n  color: #64748b;\n}\n\n.dark .hold-drawer-tab-btn-new:hover {\n  color: #cbd5e1;\n}\n\n.dark .hold-drawer-tab-btn-new.active {\n  background-color: #1e293b;\n  color: #f1f5f9;\n  box-shadow: 0 1px 3px rgba(0,0,0,0.4);\n}\n\n.dark .hold-drawer-search-input-new {\n  background-color: #0f172a;\n  border-color: #334155;\n  color: #e2e8f0;\n}\n\n.dark .hold-drawer-search-input-new:focus {\n  background-color: #1e293b;\n  border-color: #475569;\n}\n\n.dark .hold-drawer-search-input-new::placeholder {\n  color: #64748b;\n}\n\n.dark .hold-drawer-body {\n  background-color: #0f172a;\n}\n\n.dark .hold-drawer-table-container {\n  background-color: #1e293b;\n  border-color: #334155;\n  box-shadow: 0 8px 24px rgba(0,0,0,0.4);\n}\n\n.dark .hold-drawer-table-header {\n  background-color: #162032;\n  border-bottom-color: #334155;\n  color: #64748b;\n}\n\n.dark .hold-drawer-table-body > * + * {\n  border-top-color: #334155;\n}\n\n.dark .hold-drawer-table-row:hover {\n  background-color: rgba(30, 41, 59, 0.8);\n}\n\n.dark .hold-drawer-order-id-badge {\n  background-color: #0f172a;\n  color: #94a3b8;\n}\n\n.dark .hold-drawer-customer-name-text {\n  color: #f1f5f9;\n}\n\n.dark .hold-drawer-item-count-text,\n.dark .hold-drawer-products-text {\n  color: #64748b;\n}\n\n.dark .hold-drawer-time-cell {\n  color: #94a3b8;\n}\n\n.dark .hold-drawer-total-text {\n  color: #f1f5f9;\n}\n\n.dark .hold-drawer-pagination {\n  background-color: #1e293b;\n  border-top-color: #334155;\n}\n\n.dark .hold-drawer-pagination-text {\n  color: #64748b;\n}\n\n.dark .hold-drawer-page-btn {\n  background-color: #0f172a;\n  border-color: #334155;\n  color: #94a3b8;\n}\n\n.dark .hold-drawer-page-btn:hover:not(:disabled) {\n  background-color: #1e293b;\n  color: #f1f5f9;\n  border-color: #475569;\n}\n\n.dark .hod-discard-modal-box {\n  background-color: #1e293b;\n}\n\n.dark .hod-discard-modal-header {\n  background-color: #1e293b;\n  border-bottom-color: #334155;\n}\n\n.dark .hod-discard-modal-actions {\n  background-color: #0f172a;\n}\n\n.dark .hod-discard-modal-btn-cancel {\n  background-color: #1e293b;\n  border-color: #334155;\n  color: #94a3b8;\n}\n\n.dark .hod-discard-modal-btn-cancel:hover {\n  background-color: #334155;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
